// Author TianHaiQing
// Date 2022-06-14 20:26:00

import * as model from "@/model/party-building/PartyBuildingTestModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.PartyBuildingTest(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_PARTY_BUILDING_URL,
    })
    .buildStore()
